import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import { Button } from "@/components/ui/button";
import api, { apiErr } from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function AdminUsers() {
  const [users, setUsers] = useState(null);
  const load = () => api.get("/admin/users").then(({ data }) => setUsers(data.users)).catch(() => setUsers([]));
  useEffect(() => { load(); }, []);

  const toggle = async (u) => {
    try { await api.patch(`/admin/users/${u.id}/status`, { status: u.status === "active" ? "suspended" : "active" }); toast.success("Güncellendi."); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (!users) return <Spinner />;
  return (
    <div>
      <PageHeader title="Kullanıcılar" desc="Platformdaki tüm kullanıcı ve merchant hesapları." />
      {users.length === 0 ? <EmptyState title="Kullanıcı yok" /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40"><tr className="text-left text-xs text-muted-foreground">
                {["Ad", "E-posta", "Firma", "Rol", "Durum", "Kayıt", "İşlem"].map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-border" data-testid="admin-users-table">
                {users.map((u) => (
                  <tr key={u.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 font-medium">{u.name}</td>
                    <td className="px-4 py-3 text-muted-foreground">{u.email}</td>
                    <td className="px-4 py-3">{u.company || "-"}</td>
                    <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${u.role === "admin" ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"}`}>{u.role}</span></td>
                    <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${u.status === "active" ? "bg-emerald-500/10 text-emerald-500" : "bg-red-500/10 text-red-500"}`}>{u.status === "active" ? "Aktif" : "Askıda"}</span></td>
                    <td className="px-4 py-3 text-xs text-muted-foreground">{formatDate(u.created_at)}</td>
                    <td className="px-4 py-3">{u.role !== "admin" && <Button size="sm" variant="outline" className="rounded-full" onClick={() => toggle(u)}>{u.status === "active" ? "Askıya Al" : "Aktifleştir"}</Button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
